"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FB = void 0;
var app_1 = require("firebase/app");
var auth_1 = require("firebase/auth");
var database_1 = require("firebase/database");
var firestore_1 = require("firebase/firestore");
var storage_1 = require("firebase/storage");
var lodash_1 = require("lodash");
var react_1 = require("react");
var auth_2 = require("react-firebase-hooks/auth");
var FB = /** @class */ (function () {
    function FB(config, siteConfig) {
        var _this = this;
        this.app = "";
        this.db = "";
        this.auth = "";
        this.storage = "";
        this.database = "";
        this.getAuthenticatedUserUid = function () {
            var user = _this.auth.currentUser;
            if (user) {
                return user.uid;
            }
            else {
                return false;
            }
        };
        this.storageMethods = {
            getUserStorageFolder: function (path) { return __awaiter(_this, void 0, void 0, function () {
                var uid, storage, storageRef, res, files, error_1;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            uid = this.getAuthenticatedUserUid();
                            if (!!uid) return [3 /*break*/, 1];
                            return [2 /*return*/, false];
                        case 1:
                            storage = (0, storage_1.getStorage)();
                            storageRef = (0, storage_1.ref)(storage, "users/" + uid + "/" + this.siteConfig.id + "/Main/" + path);
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 5, , 6]);
                            return [4 /*yield*/, (0, storage_1.listAll)(storageRef)];
                        case 3:
                            res = _a.sent();
                            return [4 /*yield*/, Promise.all(res.items.map(function (item) { return __awaiter(_this, void 0, void 0, function () {
                                    var downloadURL;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, (0, storage_1.getDownloadURL)(item)];
                                            case 1:
                                                downloadURL = _a.sent();
                                                return [2 /*return*/, {
                                                        name: item.name,
                                                        fullPath: item.fullPath,
                                                        downloadURL: downloadURL,
                                                    }];
                                        }
                                    });
                                }); }))];
                        case 4:
                            files = _a.sent();
                            return [2 /*return*/, files];
                        case 5:
                            error_1 = _a.sent();
                            console.log(error_1);
                            return [2 /*return*/, false];
                        case 6: return [2 /*return*/];
                    }
                });
            }); },
            getStorageFolder: function (path) { return __awaiter(_this, void 0, void 0, function () {
                var storage, storageRef, res, files, error_2;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            storage = (0, storage_1.getStorage)();
                            storageRef = (0, storage_1.ref)(storage, this.siteConfig.id + "/Main/" + path);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, , 5]);
                            return [4 /*yield*/, (0, storage_1.listAll)(storageRef)];
                        case 2:
                            res = _a.sent();
                            return [4 /*yield*/, Promise.all(res.items.map(function (item) { return __awaiter(_this, void 0, void 0, function () {
                                    var downloadURL;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, (0, storage_1.getDownloadURL)(item)];
                                            case 1:
                                                downloadURL = _a.sent();
                                                return [2 /*return*/, {
                                                        name: item.name,
                                                        fullPath: item.fullPath,
                                                        downloadURL: downloadURL,
                                                    }];
                                        }
                                    });
                                }); }))];
                        case 3:
                            files = _a.sent();
                            return [2 /*return*/, files];
                        case 4:
                            error_2 = _a.sent();
                            console.log(error_2);
                            return [2 /*return*/, false];
                        case 5: return [2 /*return*/];
                    }
                });
            }); },
            uploadFile: function (path, file, log) { return __awaiter(_this, void 0, void 0, function () {
                var logMessage, logError, uid, storageRef, uploadTask_1;
                var _this = this;
                return __generator(this, function (_a) {
                    logMessage = function (message) {
                        if (log) {
                            console.log(message);
                        }
                    };
                    logError = function (error) {
                        if (log) {
                            console.error(error);
                        }
                    };
                    uid = this.getAuthenticatedUserUid();
                    if (!uid) {
                        logMessage("No authenticated user found.");
                        return [2 /*return*/, false];
                    }
                    else {
                        storageRef = (0, storage_1.ref)(this.storage, "users/" +
                            uid +
                            "/" +
                            this.siteConfig.id +
                            "/Main/" +
                            path +
                            "/" +
                            file.name);
                        try {
                            uploadTask_1 = (0, storage_1.uploadBytesResumable)(storageRef, file);
                            return [2 /*return*/, new Promise(function (resolve, reject) {
                                    uploadTask_1.on("state_changed", function (snapshot) {
                                        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                                        logMessage("Upload is ".concat(progress, "% done"));
                                    }, function (error) {
                                        logError(error);
                                        reject(error);
                                    }, function () { return __awaiter(_this, void 0, void 0, function () {
                                        var downloadURL, error_3;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    _a.trys.push([0, 2, , 3]);
                                                    return [4 /*yield*/, (0, storage_1.getDownloadURL)(uploadTask_1.snapshot.ref)];
                                                case 1:
                                                    downloadURL = _a.sent();
                                                    logMessage("File available at ".concat(downloadURL));
                                                    resolve({
                                                        name: file.name,
                                                        fullPath: "users/" +
                                                            uid +
                                                            "/" +
                                                            this.siteConfig.id +
                                                            "/Main/" +
                                                            path +
                                                            "/" +
                                                            file.name,
                                                        downloadURL: downloadURL,
                                                    });
                                                    return [3 /*break*/, 3];
                                                case 2:
                                                    error_3 = _a.sent();
                                                    logError("Error getting download URL: ".concat(error_3));
                                                    reject(error_3);
                                                    return [3 /*break*/, 3];
                                                case 3: return [2 /*return*/];
                                            }
                                        });
                                    }); });
                                })];
                        }
                        catch (error) {
                            logError("Error uploading file: ".concat(error));
                            return [2 /*return*/, false];
                        }
                    }
                    return [2 /*return*/];
                });
            }); },
            uploadOtherUserFile: function (path, userId, file) { return __awaiter(_this, void 0, void 0, function () {
                var storageRef, uploadTask_2;
                var _this = this;
                return __generator(this, function (_a) {
                    if (!userId) {
                        return [2 /*return*/, false];
                    }
                    else {
                        storageRef = (0, storage_1.ref)(this.storage, "users/" +
                            userId +
                            "/" +
                            this.siteConfig.id +
                            "/Main/" +
                            path +
                            "/" +
                            file.name);
                        try {
                            uploadTask_2 = (0, storage_1.uploadBytesResumable)(storageRef, file);
                            // We return a new promise that resolves with the file object when the upload completes
                            return [2 /*return*/, new Promise(function (resolve, reject) {
                                    uploadTask_2.on("state_changed", function (snapshot) {
                                        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                                    }, function (error) {
                                        console.error(error);
                                        reject(error);
                                    }, function () { return __awaiter(_this, void 0, void 0, function () {
                                        var downloadURL;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, (0, storage_1.getDownloadURL)(uploadTask_2.snapshot.ref)];
                                                case 1:
                                                    downloadURL = _a.sent();
                                                    resolve({
                                                        name: file.name,
                                                        fullPath: "users/" +
                                                            userId +
                                                            "/" +
                                                            this.siteConfig.id +
                                                            "/Main/" +
                                                            path +
                                                            "/" +
                                                            file.name,
                                                        downloadURL: downloadURL,
                                                    });
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); });
                                })];
                        }
                        catch (error) {
                            console.error("Error uploading file:", error);
                            return [2 /*return*/, false];
                        }
                    }
                    return [2 /*return*/];
                });
            }); },
            uploadFileNoAuth: function (path, file, log) { return __awaiter(_this, void 0, void 0, function () {
                var storageRef, logMessage, logError, uploadTask_3;
                var _this = this;
                return __generator(this, function (_a) {
                    storageRef = (0, storage_1.ref)(this.storage, path + "/" + file.name);
                    logMessage = function (message) {
                        if (log) {
                            console.log(message);
                        }
                    };
                    logError = function (error) {
                        if (log) {
                            console.error(error);
                        }
                    };
                    try {
                        uploadTask_3 = (0, storage_1.uploadBytesResumable)(storageRef, file);
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                uploadTask_3.on("state_changed", function (snapshot) {
                                    var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                                    logMessage("Upload is ".concat(progress, "% done"));
                                }, function (error) {
                                    logError(error);
                                    reject(error);
                                }, function () { return __awaiter(_this, void 0, void 0, function () {
                                    var downloadURL, error_4;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                _a.trys.push([0, 2, , 3]);
                                                return [4 /*yield*/, (0, storage_1.getDownloadURL)(uploadTask_3.snapshot.ref)];
                                            case 1:
                                                downloadURL = _a.sent();
                                                logMessage("File available at ".concat(downloadURL));
                                                resolve(downloadURL);
                                                return [3 /*break*/, 3];
                                            case 2:
                                                error_4 = _a.sent();
                                                logError("Error getting download URL: ".concat(error_4));
                                                reject(error_4);
                                                return [3 /*break*/, 3];
                                            case 3: return [2 /*return*/];
                                        }
                                    });
                                }); });
                            })];
                    }
                    catch (error) {
                        logError("Error uploading file: ".concat(error));
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/];
                });
            }); },
            deleteFile: function (path) { return __awaiter(_this, void 0, void 0, function () {
                var storageRef, error_5;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            storageRef = (0, storage_1.ref)(this.storage, path);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, (0, storage_1.deleteObject)(storageRef)];
                        case 2:
                            _a.sent();
                            console.log("File deleted successfully");
                            return [3 /*break*/, 4];
                        case 3:
                            error_5 = _a.sent();
                            console.error("Error deleting file:", error_5);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); },
        };
        this.contacts = {
            getUserContacts: function () { return __awaiter(_this, void 0, void 0, function () {
                var uid, userContactsCollectionRef, contactsQuerySnapshot, contactObjects;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            uid = this.getAuthenticatedUserUid();
                            userContactsCollectionRef = (0, firestore_1.collection)(this.db, "users/" + uid + "/" + this.siteConfig.id + "/Main/contacts");
                            return [4 /*yield*/, (0, firestore_1.getDocs)(userContactsCollectionRef)];
                        case 1:
                            contactsQuerySnapshot = _a.sent();
                            contactObjects = [];
                            contactsQuerySnapshot.forEach(function (contactDoc) {
                                var contactData = contactDoc.data();
                                contactObjects.push({
                                    user: contactData.user,
                                    type: contactData.type,
                                    initials: contactData.initials,
                                    email: contactData.email,
                                    first: contactData.first,
                                    last: contactData.last,
                                });
                            });
                            return [2 /*return*/, contactObjects];
                    }
                });
            }); },
            addExistingUserToContacts: function (userId, type) { return __awaiter(_this, void 0, void 0, function () {
                var uid, contactUserDocRef, contactUserDoc, contactUserData, newContact, userContactsCollectionRef;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            uid = this.getAuthenticatedUserUid();
                            contactUserDocRef = (0, firestore_1.doc)(this.db, "users/" + userId);
                            return [4 /*yield*/, (0, firestore_1.getDoc)(contactUserDocRef)];
                        case 1:
                            contactUserDoc = _a.sent();
                            if (!contactUserDoc.exists()) {
                                console.warn("User document not found");
                                return [2 /*return*/];
                            }
                            contactUserData = contactUserDoc.data();
                            newContact = {
                                user: userId,
                                type: type,
                                initials: contactUserData.first[0] + contactUserData.last[0],
                                email: contactUserData.email,
                                first: contactUserData.first,
                                last: contactUserData.last,
                            };
                            userContactsCollectionRef = (0, firestore_1.collection)(this.db, "users/" + uid + "/" + this.siteConfig.id + "/Contacts");
                            return [4 /*yield*/, (0, firestore_1.addDoc)(userContactsCollectionRef, newContact)];
                        case 2:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); },
            addNewUserToContacts: function (user, type) { return __awaiter(_this, void 0, void 0, function () {
                var uid, newUserDocRef, newUser, newUserId, newContact, userContactsCollectionRef;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            uid = this.getAuthenticatedUserUid();
                            newUserDocRef = (0, firestore_1.doc)(this.db, "users");
                            newUser = __assign(__assign({}, user), { account: false });
                            return [4 /*yield*/, (0, firestore_1.setDoc)(newUserDocRef, newUser)];
                        case 1:
                            _a.sent();
                            newUserId = newUserDocRef.id;
                            newContact = {
                                user: newUserId,
                                type: type,
                                initials: user.first[0] + user.last[0],
                                email: user.email,
                                first: user.first,
                                last: user.last,
                            };
                            userContactsCollectionRef = (0, firestore_1.collection)(this.db, "users/" + uid + "/" + this.siteConfig.id + "/Contacts");
                            return [4 /*yield*/, (0, firestore_1.addDoc)(userContactsCollectionRef, newContact)];
                        case 2:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); },
            removeUserFromContacts: function (contactIdToRemove) { return __awaiter(_this, void 0, void 0, function () {
                var uid, contactDocRef;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            uid = this.getAuthenticatedUserUid();
                            contactDocRef = (0, firestore_1.doc)(this.db, "users/" +
                                uid +
                                "/" +
                                this.siteConfig.id +
                                "/Main/contacts/" +
                                contactIdToRemove);
                            // Deleting the document in the contacts collection
                            return [4 /*yield*/, (0, firestore_1.deleteDoc)(contactDocRef)];
                        case 1:
                            // Deleting the document in the contacts collection
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); },
            searchAllUsers: function (email) { return __awaiter(_this, void 0, void 0, function () {
                var ots, q, querySnapshot, error_6;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            q = (0, firestore_1.query)((0, firestore_1.collection)(this.db, "users"), (0, firestore_1.where)("apps", "array-contains", this.siteConfig.id), (0, firestore_1.where)("email", "==", email));
                            return [4 /*yield*/, (0, firestore_1.getDocs)(q)];
                        case 1:
                            querySnapshot = _a.sent();
                            querySnapshot.forEach(function (doc) {
                                // doc.data() is never undefined for query doc snapshots
                                ots = { id: doc.id, data: doc.data() };
                            });
                            return [3 /*break*/, 3];
                        case 2:
                            error_6 = _a.sent();
                            console.log("Error getting documents: ", error_6);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/, ots ? ots : null];
                    }
                });
            }); },
        };
        this.docs = {
            setUserDoc: function (path, data) { return __awaiter(_this, void 0, void 0, function () {
                var test, ots;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            test = this.getAuthenticatedUserUid();
                            if (!!test) return [3 /*break*/, 1];
                            return [2 /*return*/, false];
                        case 1: return [4 /*yield*/, (0, firestore_1.setDoc)((0, firestore_1.doc)(this.db, "users/" + test + "/" + this.siteConfig.id + "/Main/" + path), data, { merge: true } // This will merge the fields rather than replacing the document
                            )];
                        case 2:
                            ots = _a.sent();
                            if (ots) {
                                return [2 /*return*/, true];
                            }
                            return [2 /*return*/, false];
                    }
                });
            }); },
            setDoc: function (path, data) { return __awaiter(_this, void 0, void 0, function () {
                var ots, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, (0, firestore_1.setDoc)((0, firestore_1.doc)(this.db, this.siteConfig.id + "/Main/" + path), data, { merge: true } // This will merge the fields rather than replacing the document
                                )];
                        case 1:
                            ots = _b.sent();
                            return [2 /*return*/, true];
                        case 2:
                            _a = _b.sent();
                            return [2 /*return*/, false];
                        case 3: return [2 /*return*/];
                    }
                });
            }); },
            setBaseDoc: function (path, data) { return __awaiter(_this, void 0, void 0, function () {
                var ots, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, (0, firestore_1.setDoc)((0, firestore_1.doc)(this.db, path), data, { merge: true } // This will merge the fields rather than replacing the document
                                )];
                        case 1:
                            ots = _a.sent();
                            return [2 /*return*/, true];
                        case 2:
                            e_1 = _a.sent();
                            return [2 /*return*/, e_1];
                        case 3: return [2 /*return*/];
                    }
                });
            }); },
            deleteUserDoc: function (path) { return __awaiter(_this, void 0, void 0, function () {
                var test, docRef;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            test = this.getAuthenticatedUserUid();
                            if (!!test) return [3 /*break*/, 1];
                            return [2 /*return*/, false];
                        case 1:
                            docRef = (0, firestore_1.doc)(this.db, "users/" + test + "/" + this.siteConfig.id + "/Main/" + path);
                            return [4 /*yield*/, (0, firestore_1.deleteDoc)(docRef)];
                        case 2:
                            _a.sent();
                            return [2 /*return*/, true];
                    }
                });
            }); },
            setUser: function (data) { return __awaiter(_this, void 0, void 0, function () {
                var test, ots;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            test = this.getAuthenticatedUserUid();
                            if (!!test) return [3 /*break*/, 1];
                            return [2 /*return*/, false];
                        case 1: return [4 /*yield*/, (0, firestore_1.setDoc)((0, firestore_1.doc)(this.db, "users/" + test), data, { merge: true } // This will merge the fields rather than replacing the document
                            )];
                        case 2:
                            ots = _a.sent();
                            if (ots) {
                                return [2 /*return*/, true];
                            }
                            return [2 /*return*/, false];
                    }
                });
            }); },
            getUser: function () { return __awaiter(_this, void 0, void 0, function () {
                var test, ots;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            test = this.getAuthenticatedUserUid();
                            if (!!test) return [3 /*break*/, 1];
                            return [2 /*return*/, false];
                        case 1: return [4 /*yield*/, (0, firestore_1.getDoc)((0, firestore_1.doc)(this.db, "users/" + test))];
                        case 2:
                            ots = _a.sent();
                            return [2 /*return*/, ots.data()];
                    }
                });
            }); },
            getUploadLink: function (id, docId) { return __awaiter(_this, void 0, void 0, function () {
                var ots;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, firestore_1.getDoc)((0, firestore_1.doc)(this.db, "utils/uploadLinks/" + id + "/" + docId))];
                        case 1:
                            ots = _a.sent();
                            return [2 /*return*/, {
                                    data: ots.data(),
                                    id: ots.id,
                                }];
                    }
                });
            }); },
            generateUploadLink: function (id, data) { return __awaiter(_this, void 0, void 0, function () {
                var ots;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, firestore_1.setDoc)((0, firestore_1.doc)(this.db, "utils/uploadLinks/" + id), data)];
                        case 1:
                            ots = _a.sent();
                            if (ots) {
                                return [2 /*return*/, true];
                            }
                            return [2 /*return*/, false];
                    }
                });
            }); },
            setOtherUserDoc: function (path, data, otherUser) { return __awaiter(_this, void 0, void 0, function () {
                var ots;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!test) return [3 /*break*/, 1];
                            return [2 /*return*/, false];
                        case 1: return [4 /*yield*/, (0, firestore_1.setDoc)((0, firestore_1.doc)(this.db, "users/" + otherUser + "/" + this.siteConfig.id + "/Main/" + path), data)];
                        case 2:
                            ots = _a.sent();
                            if (ots) {
                                return [2 /*return*/, true];
                            }
                            return [2 /*return*/, false];
                    }
                });
            }); },
            getUserCollection: function (path) { return __awaiter(_this, void 0, void 0, function () {
                var test, ots, e_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            test = this.getAuthenticatedUserUid();
                            console.log(test);
                            if (!!test) return [3 /*break*/, 1];
                            return [2 /*return*/, false];
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, (0, firestore_1.getDocs)((0, firestore_1.collection)(this.db, "users/" + test + "/" + this.siteConfig.id + "/Main/" + path))];
                        case 2:
                            ots = _a.sent();
                            if (ots.docs.length > 0) {
                                return [2 /*return*/, ots.docs.map(function (doc) {
                                        var temp = doc.data();
                                        var ots = {
                                            id: doc.id,
                                            data: doc.data(),
                                        };
                                        return ots;
                                    })];
                            }
                            else {
                                return [2 /*return*/, []];
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            e_2 = _a.sent();
                            console.error(e_2);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); },
            getCollection: function (path) { return __awaiter(_this, void 0, void 0, function () {
                var ots, e_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, (0, firestore_1.getDocs)((0, firestore_1.collection)(this.db, this.siteConfig.id + "/Main/" + path))];
                        case 1:
                            ots = _a.sent();
                            if (ots.docs.length > 0) {
                                return [2 /*return*/, ots.docs.map(function (doc) {
                                        var temp = doc.data();
                                        var ots = {
                                            id: doc.id,
                                            data: doc.data(),
                                        };
                                        return ots;
                                    })];
                            }
                            else {
                                return [2 /*return*/, []];
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            e_3 = _a.sent();
                            console.error(e_3);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); },
            getBaseCollection: function (path) { return __awaiter(_this, void 0, void 0, function () {
                var ots, e_4;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, (0, firestore_1.getDocs)((0, firestore_1.collection)(this.db, path))];
                        case 1:
                            ots = _a.sent();
                            if (ots.docs.length > 0) {
                                return [2 /*return*/, ots.docs.map(function (doc) {
                                        var temp = doc.data();
                                        var ots = {
                                            id: doc.id,
                                            data: doc.data(),
                                        };
                                        return ots;
                                    })];
                            }
                            else {
                                return [2 /*return*/, []];
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            e_4 = _a.sent();
                            console.error(e_4);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); },
            // Make sure to define getAuthenticatedUserUid() and this.siteConfig.id properties in the class
            getUserDoc: function (path) { return __awaiter(_this, void 0, void 0, function () {
                var test, ots;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            test = this.getAuthenticatedUserUid();
                            if (!!test) return [3 /*break*/, 1];
                            return [2 /*return*/, false];
                        case 1: return [4 /*yield*/, (0, firestore_1.getDoc)((0, firestore_1.doc)(this.db, "users/" + test + "/" + this.siteConfig.id + "/Main/" + path))];
                        case 2:
                            ots = _a.sent();
                            return [2 /*return*/, {
                                    data: ots.data(),
                                    id: ots.id,
                                }];
                    }
                });
            }); },
            getDoc: function (path) { return __awaiter(_this, void 0, void 0, function () {
                var ots;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, firestore_1.getDoc)((0, firestore_1.doc)(this.db, this.siteConfig.id + "/Main/" + path))];
                        case 1:
                            ots = _a.sent();
                            return [2 /*return*/, {
                                    data: ots.data(),
                                    id: ots.id,
                                }];
                    }
                });
            }); },
            getBaseDoc: function (path) { return __awaiter(_this, void 0, void 0, function () {
                var ots;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, firestore_1.getDoc)((0, firestore_1.doc)(this.db, path))];
                        case 1:
                            ots = _a.sent();
                            return [2 /*return*/, {
                                    data: ots.data(),
                                    id: ots.id,
                                }];
                    }
                });
            }); },
            getTheme: function () { return __awaiter(_this, void 0, void 0, function () {
                var ots;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, firestore_1.getDoc)((0, firestore_1.doc)(this.db, "siteThemes/" + this.siteConfig.id))];
                        case 1:
                            ots = _a.sent();
                            return [2 /*return*/, ots.data()];
                    }
                });
            }); },
            setTheme: function (local) { return __awaiter(_this, void 0, void 0, function () {
                var ots;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, firestore_1.setDoc)((0, firestore_1.doc)(this.db, "siteThemes/" + this.siteConfig.id), local)];
                        case 1:
                            ots = _a.sent();
                            return [2 /*return*/, local];
                    }
                });
            }); },
        };
        /**
         * A custom hook for throttling state updates to Firebase.
         *
         * @function useThrottleChange
         * @param {string} path - The path in Firebase where the data should be stored.
         * @param {number} [ms=150] - The number of milliseconds to throttle the state update.
         * @returns {Array} - An array containing the current state value and a function to update it.
         *
         * @example
         * const [data, setData] = useThrottleChange('path/to/your/firebase/document');
         *
         * return (
         *   <input
         *     type="text"
         *     value={data}
         *     onChange={(e) => setData(e.target.value)}
         *   />
         * );
         */
        this.hooks = {
            useLocalStorage: function (key) {
                var _a = (0, react_1.useState)(function () {
                    try {
                        return window.localStorage.getItem(key);
                    }
                    catch (error) {
                        console.error("Error reading localStorage key \u201C".concat(key, "\u201D:"), error);
                        return null;
                    }
                }), value = _a[0], setValue = _a[1];
                (0, react_1.useEffect)(function () {
                    var onStorageChange = function (e) {
                        if (e.key === key) {
                            setValue(e.newValue);
                        }
                    };
                    window.addEventListener("storage", onStorageChange);
                    return function () {
                        window.removeEventListener("storage", onStorageChange);
                    };
                }, [key]);
                return value;
            },
            useThrottleChange: function (path, ms) {
                if (ms === void 0) { ms = 150; }
                var _a = (0, react_1.useState)(""), data = _a[0], setData = _a[1];
                var _b = (0, react_1.useState)(false), initialDataFetched = _b[0], setInitialDataFetched = _b[1];
                (0, react_1.useEffect)(function () {
                    var fetchInitialData = function () { return __awaiter(_this, void 0, void 0, function () {
                        var doc_1, error_7;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, this.docs.getUserDoc(path)];
                                case 1:
                                    doc_1 = _a.sent();
                                    if (doc_1)
                                        setData(doc_1.data);
                                    setInitialDataFetched(true);
                                    return [3 /*break*/, 3];
                                case 2:
                                    error_7 = _a.sent();
                                    console.error("Error fetching initial data:", error_7);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); };
                    if (!initialDataFetched) {
                        fetchInitialData();
                    }
                }, [path, initialDataFetched]);
                (0, react_1.useEffect)(function () {
                    var updateFirestore = (0, lodash_1.throttle)(function (newValue) { return __awaiter(_this, void 0, void 0, function () {
                        var result, error_8;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, this.docs.setUserDoc(path, {
                                            value: newValue,
                                        })];
                                case 1:
                                    result = _a.sent();
                                    if (result) {
                                        console.log("Value updated successfully");
                                    }
                                    else {
                                        console.error("Error updating value: User not authenticated");
                                    }
                                    return [3 /*break*/, 3];
                                case 2:
                                    error_8 = _a.sent();
                                    console.error("Error updating value:", error_8);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); }, ms);
                    if (initialDataFetched && data) {
                        updateFirestore(data);
                    }
                }, [data, ms, path, initialDataFetched]);
                return [data, setData];
            },
            useThrottleField: function (path, field, ms, log) {
                if (ms === void 0) { ms = 150; }
                var user = _this.getAuthenticatedUserUid();
                var initialState = Array.isArray([]) ? [] : "";
                var _a = (0, react_1.useState)(initialState), data = _a[0], setData = _a[1];
                var _b = (0, react_1.useState)(false), initialDataFetched = _b[0], setInitialDataFetched = _b[1];
                (0, react_1.useEffect)(function () {
                    // log && console.log("useEffect 1 (with Auth)");
                    var fetchInitialData = function () { return __awaiter(_this, void 0, void 0, function () {
                        var doc_2, error_9;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, this.docs.getUserDoc(path)];
                                case 1:
                                    doc_2 = _a.sent();
                                    log && console.log(doc_2);
                                    if (doc_2) {
                                        if (doc_2.data) {
                                            log && console.log(doc_2.data[field]);
                                            setData(doc_2.data[field]);
                                        }
                                    }
                                    setInitialDataFetched(true);
                                    return [3 /*break*/, 3];
                                case 2:
                                    error_9 = _a.sent();
                                    console.error("Error fetching initial data:", error_9);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); };
                    fetchInitialData();
                }, []);
                (0, react_1.useEffect)(function () {
                    // log && console.log("useEffect 2 (with Auth)");
                    var updateFirestore = (0, lodash_1.throttle)(function (newValue) { return __awaiter(_this, void 0, void 0, function () {
                        var ots, result, error_10;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 3, , 4]);
                                    if (!(newValue !== undefined)) return [3 /*break*/, 2];
                                    ots = {};
                                    ots[field] = newValue;
                                    log && console.log(ots);
                                    return [4 /*yield*/, this.docs.setUserDoc(path, ots)];
                                case 1:
                                    result = _a.sent();
                                    _a.label = 2;
                                case 2: return [3 /*break*/, 4];
                                case 3:
                                    error_10 = _a.sent();
                                    console.error("Error updating value:", error_10);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); }, ms);
                    if (initialDataFetched && data !== undefined) {
                        // Add a check for undefined data here too
                        updateFirestore(data);
                    }
                }, [data]);
                return [data, setData];
            },
            useThrottleBaseField: function (path, field, ms, log) {
                if (ms === void 0) { ms = 150; }
                var initialState = Array.isArray([]) ? [] : "";
                var _a = (0, react_1.useState)(initialState), data = _a[0], setData = _a[1];
                var _b = (0, react_1.useState)(false), initialDataFetched = _b[0], setInitialDataFetched = _b[1];
                (0, react_1.useEffect)(function () {
                    log && console.log("useEffect 1 (with Auth)");
                    var fetchInitialData = function () { return __awaiter(_this, void 0, void 0, function () {
                        var doc_3, error_11;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    log && console.log("fetch initial data (with Auth)");
                                    return [4 /*yield*/, this.docs.getBaseDoc(path)];
                                case 1:
                                    doc_3 = _a.sent();
                                    log && console.log(doc_3);
                                    if (doc_3) {
                                        if (doc_3.data) {
                                            log && console.log(doc_3.data[field]);
                                            setData(doc_3.data[field]);
                                        }
                                    }
                                    setInitialDataFetched(true);
                                    return [3 /*break*/, 3];
                                case 2:
                                    error_11 = _a.sent();
                                    console.error("Error fetching initial data:", error_11);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); };
                    fetchInitialData();
                }, [path, field]);
                (0, react_1.useEffect)(function () {
                    log && console.log("useEffect 2 (with Auth)");
                    var updateFirestore = (0, lodash_1.throttle)(function (newValue) { return __awaiter(_this, void 0, void 0, function () {
                        var ots, result, error_12;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 3, , 4]);
                                    if (!(newValue !== undefined)) return [3 /*break*/, 2];
                                    ots = {};
                                    ots[field] = newValue;
                                    log && console.log(ots);
                                    return [4 /*yield*/, this.docs.setBaseDoc(path, ots)];
                                case 1:
                                    result = _a.sent();
                                    log && console.log(result);
                                    _a.label = 2;
                                case 2: return [3 /*break*/, 4];
                                case 3:
                                    error_12 = _a.sent();
                                    console.error("Error updating value:", error_12);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); }, ms);
                    if (initialDataFetched && data !== undefined) {
                        // Add a check for undefined data here too
                        updateFirestore(data);
                    }
                }, [data]);
                return [data, setData];
            },
            useThrottleFieldNoAuth: function (path, field, ms, log) {
                if (ms === void 0) { ms = 150; }
                var initialState = Array.isArray([]) ? [] : "";
                var _a = (0, react_1.useState)(initialState), data = _a[0], setData = _a[1];
                var _b = (0, react_1.useState)(false), initialDataFetched = _b[0], setInitialDataFetched = _b[1];
                (0, react_1.useEffect)(function () {
                    log && console.log("useEffect 1");
                    var fetchInitialData = function () { return __awaiter(_this, void 0, void 0, function () {
                        var doc_4, error_13;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    log && console.log("fetch intitoal data");
                                    return [4 /*yield*/, this.docs.getDoc(path)];
                                case 1:
                                    doc_4 = _a.sent();
                                    log && console.log(doc_4);
                                    if (doc_4) {
                                        if (doc_4.data) {
                                            log && console.log(doc_4.data[field]);
                                            setData(doc_4.data[field]);
                                        }
                                    }
                                    setInitialDataFetched(true);
                                    return [3 /*break*/, 3];
                                case 2:
                                    error_13 = _a.sent();
                                    console.error("Error fetching initial data:", error_13);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); };
                    fetchInitialData();
                }, [path, field]);
                (0, react_1.useEffect)(function () {
                    log && console.log("useEffect 2");
                    var updateFirestore = (0, lodash_1.throttle)(function (newValue) { return __awaiter(_this, void 0, void 0, function () {
                        var prev, ots, result, error_14;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    log && console.log("updateFirestore");
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 4, , 5]);
                                    return [4 /*yield*/, this.docs.getDoc(path)];
                                case 2:
                                    prev = _a.sent();
                                    log && console.log(prev);
                                    if (prev.data) {
                                        prev = prev.data;
                                    }
                                    else {
                                        prev = {};
                                    }
                                    ots = __assign({}, prev);
                                    ots[field] = newValue;
                                    log && console.log(ots);
                                    return [4 /*yield*/, this.docs.setDoc(path, ots)];
                                case 3:
                                    result = _a.sent();
                                    return [3 /*break*/, 5];
                                case 4:
                                    error_14 = _a.sent();
                                    console.error("Error updating value:", error_14);
                                    return [3 /*break*/, 5];
                                case 5: return [2 /*return*/];
                            }
                        });
                    }); }, ms);
                    if (initialDataFetched) {
                        updateFirestore(data);
                    }
                }, [data]);
                return [data, setData];
            },
            useThrottleUserField: function (field, ms) {
                if (ms === void 0) { ms = 150; }
                var _a = (0, auth_2.useAuthState)(_this.auth), user = _a[0], loading = _a[1], error = _a[2];
                var _b = (0, react_1.useState)(""), data = _b[0], setData = _b[1];
                var _c = (0, react_1.useState)(false), initialDataFetched = _c[0], setInitialDataFetched = _c[1];
                (0, react_1.useEffect)(function () {
                    if (user) {
                        var fetchInitialData = function () { return __awaiter(_this, void 0, void 0, function () {
                            var doc_5, error_15;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, this.docs.getUser()];
                                    case 1:
                                        doc_5 = _a.sent();
                                        if (doc_5) {
                                            setData(doc_5[field]);
                                        }
                                        setInitialDataFetched(true);
                                        return [3 /*break*/, 3];
                                    case 2:
                                        error_15 = _a.sent();
                                        console.error("Error fetching initial data:", error_15);
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); };
                        if (!initialDataFetched) {
                            fetchInitialData();
                        }
                    }
                }, [initialDataFetched]);
                (0, react_1.useEffect)(function () {
                    if (user) {
                        var updateFirestore = (0, lodash_1.throttle)(function (newValue) { return __awaiter(_this, void 0, void 0, function () {
                            var prev, ots, result, error_16;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 3, , 4]);
                                        return [4 /*yield*/, this.docs.getUser()];
                                    case 1:
                                        prev = _a.sent();
                                        if (prev.data) {
                                            prev = prev.data;
                                        }
                                        else {
                                            prev = {};
                                        }
                                        ots = __assign({}, prev);
                                        ots[field] = newValue;
                                        return [4 /*yield*/, this.docs.setUser(ots)];
                                    case 2:
                                        result = _a.sent();
                                        return [3 /*break*/, 4];
                                    case 3:
                                        error_16 = _a.sent();
                                        console.error("Error updating value:", error_16);
                                        return [3 /*break*/, 4];
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); }, ms);
                        if (initialDataFetched && data) {
                            updateFirestore(data);
                        }
                    }
                }, [data, ms, initialDataFetched]);
                return [data, setData];
            },
            useUserCollection: function (path) {
                var uid = _this.getAuthenticatedUserUid();
                var _a = (0, react_1.useState)([]), docs = _a[0], setDocs = _a[1];
                var _b = (0, react_1.useState)(true), loading = _b[0], setLoading = _b[1];
                var _c = (0, react_1.useState)(null), error = _c[0], setError = _c[1];
                (0, react_1.useEffect)(function () {
                    if (!uid) {
                        // Set state to indicate no data should be loaded
                        setDocs([]);
                        setLoading(false);
                        setError(null);
                        return;
                    }
                    setLoading(true);
                    // Construct the complete path
                    var completePath = "users/".concat(uid, "/").concat(_this.siteConfig.id, "/Main/").concat(path);
                    var q = (0, firestore_1.query)((0, firestore_1.collection)(_this.db, completePath));
                    var unsubscribe = (0, firestore_1.onSnapshot)(q, function (snapshot) {
                        var newDocs = snapshot.docs.map(function (doc) { return ({
                            id: doc.id,
                            data: doc.data(),
                        }); });
                        setDocs(newDocs);
                        setLoading(false);
                    }, function (err) {
                        setError(err);
                        setLoading(false);
                    });
                    return function () {
                        // Cleanup: unsubscribe to the snapshot
                        unsubscribe();
                    };
                }, [uid, path]); // Include uid in the dependency array
                return {
                    docs: docs,
                    loading: loading,
                    error: error,
                };
            },
            useCollection: function (path, complete) {
                var _a = (0, react_1.useState)([]), docs = _a[0], setDocs = _a[1];
                var _b = (0, react_1.useState)(true), loading = _b[0], setLoading = _b[1];
                var _c = (0, react_1.useState)(null), error = _c[0], setError = _c[1];
                (0, react_1.useEffect)(function () {
                    setLoading(true);
                    // Construct the complete path
                    var completePath = complete
                        ? path
                        : "".concat(_this.siteConfig.id, "/Main/").concat(path);
                    var q = (0, firestore_1.query)((0, firestore_1.collection)(_this.db, completePath));
                    var unsubscribe = (0, firestore_1.onSnapshot)(q, function (snapshot) {
                        var newDocs = snapshot.docs.map(function (doc) { return ({
                            id: doc.id,
                            data: doc.data(),
                        }); });
                        setDocs(newDocs);
                        setLoading(false);
                    }, function (err) {
                        setError(err);
                        setLoading(false);
                    });
                    return function () {
                        // Cleanup: unsubscribe to the snapshot
                        unsubscribe();
                    };
                }, [path]);
                return {
                    docs: docs,
                    loading: loading,
                    error: error,
                };
            },
            useDoc: function (path, ms, log) {
                if (ms === void 0) { ms = 150; }
                var initialState = {};
                var _a = (0, react_1.useState)(initialState), data = _a[0], setData = _a[1];
                var _b = (0, react_1.useState)(false), initialDataFetched = _b[0], setInitialDataFetched = _b[1];
                (0, react_1.useEffect)(function () {
                    log && console.log("useEffect 1 (with Auth)");
                    var fetchInitialData = function () { return __awaiter(_this, void 0, void 0, function () {
                        var doc_6, error_17;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    log && console.log("fetch initial data (with Auth)");
                                    return [4 /*yield*/, this.docs.getBaseDoc(path)];
                                case 1:
                                    doc_6 = _a.sent();
                                    log && console.log(doc_6);
                                    if (doc_6 === null || doc_6 === void 0 ? void 0 : doc_6.data) {
                                        setData(doc_6.data);
                                    }
                                    setInitialDataFetched(true);
                                    return [3 /*break*/, 3];
                                case 2:
                                    error_17 = _a.sent();
                                    console.error("Error fetching initial data:", error_17);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); };
                    fetchInitialData();
                }, [path]);
                (0, react_1.useEffect)(function () {
                    log && console.log("useEffect 2 (with Auth)");
                    var updateFirestore = (0, lodash_1.throttle)(function (updatedData) { return __awaiter(_this, void 0, void 0, function () {
                        var result, error_18;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    log && console.log(updatedData);
                                    return [4 /*yield*/, this.docs.setBaseDoc(path, updatedData)];
                                case 1:
                                    result = _a.sent();
                                    log && console.log(result);
                                    return [3 /*break*/, 3];
                                case 2:
                                    error_18 = _a.sent();
                                    console.error("Error updating value:", error_18);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); }, ms);
                    if (initialDataFetched && data) {
                        updateFirestore(data);
                    }
                }, [data]);
                var setField = function (field, value, log) {
                    setData(function (prevData) {
                        var _a;
                        return (__assign(__assign({}, prevData), (_a = {}, _a[field] = value, _a)));
                    });
                };
                return [data, setField];
            },
        };
        if (config.config) {
            this.app = (0, app_1.initializeApp)(config.config);
            this.db = (0, firestore_1.getFirestore)(this.app);
            this.auth = (0, auth_1.getAuth)(this.app);
            this.storage = (0, storage_1.getStorage)(this.app);
            this.database = (0, database_1.getDatabase)(this.app);
        }
        this.siteConfig = siteConfig;
    }
    return FB;
}());
exports.FB = FB;
